"use client"

import { useSettings } from "@/lib/settings-context"
import { HeroSection } from "@/components/home/hero-section"
import { ServicesSection } from "@/components/home/services-section"
import { WhyUsSection } from "@/components/home/why-us-section"
import { CTASection } from "@/components/home/cta-section"
import { HeroSectionModern } from "@/components/home/hero-section-modern"
import { ServicesSectionModern } from "@/components/home/services-section-modern"
import { WhyUsSectionModern } from "@/components/home/why-us-section-modern"
import { CTASectionModern } from "@/components/home/cta-section-modern"

export default function HomePage() {
  const { settings } = useSettings()
  const isModern = settings.design === "modern"

  return (
    <>
      {isModern ? <HeroSectionModern /> : <HeroSection />}
      {isModern ? <ServicesSectionModern /> : <ServicesSection />}
      {isModern ? <WhyUsSectionModern /> : <WhyUsSection />}
      {isModern ? <CTASectionModern /> : <CTASection />}
    </>
  )
}
